import Button from "../Button";
import SearchIcon from "../../Assets/Icons/outline/search-normal.svg";
import AdminContext from "../../Services/Admin";
import { useContext, useEffect, useState } from "react";

const ContributorPicker = ({ contributorPicker, setContributorPicker, setShowContributor, groupId }) => {
	const { getAllMaster } = useContext(AdminContext);
	const [dataMember, setDataMember] = useState([]);
	const [search, setSearch] = useState("");

	const getDataMember = async () => {
		const newData = await getAllMaster(
			`master/member?${groupId ? "m_groups_id=" + groupId + "&" : ""}search=${search}`
		);
		if (newData) {
			setDataMember(newData?.data);
		}
	};

	const onChange = (evt, item) => {
		if (evt) {
			setContributorPicker([...contributorPicker, item]);
		} else {
			setContributorPicker(contributorPicker.filter((a) => a.id !== item.id));
		}
	};

	useEffect(() => {
		if (groupId || !setShowContributor) {
			getDataMember();
		}
	}, [groupId, search]);

	return (
		<div className={`${!setShowContributor ? "" : "absolute z-10 right-[-400px] bottom-[-100px] pb-[100px]"}`}>
			<div className="w-[350px] flex flex-col mt-2 mx-auto rounded-3xl shadow-[0_4px_16px_0_rgba(0,0,0,0.3)] bg-white mb-5 p-3">
				<div className="relative mb-5">
					<div className="absolute inset-y-0 start-0 flex items-center ps-2.5 pointer-events-none">
						<img src={SearchIcon} className="w-[15px]" alt="" />
					</div>
					<input
						className={`border border-black text-gray-900 rounded-xl focus:ring-black focus:border-black block w-full p-1 ps-8`}
						placeholder="Search..."
						onChange={(evt) => setSearch(evt?.target?.value)}
					/>
				</div>
				<div className="bg-gray-100 rounded-lg p-3 max-h-[150px] overflow-y-auto">
					{dataMember &&
						dataMember?.map((item, index) => (
							<label key={index} htmlFor={index} className="flex items-center justify-between mb-3">
								<input
									id={index}
									type="checkbox"
									className="w-5 h-5 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2"
									checked={contributorPicker?.map((item) => item?.id)?.includes(item?.id)}
									onChange={(evt) => onChange(evt?.target?.checked, item)}
								/>
								<div className="flex flex-col text-right">
									<div className="font-semibold text-sm">{item?.name}</div>
									<div className="text-xs">{item?.roles?.[0]?.name}</div>
								</div>
							</label>
						))}
				</div>
			</div>
			{setShowContributor && (
				<Button className="py-5" onClick={() => setShowContributor(false)}>
					Done
				</Button>
			)}
		</div>
	);
};

export default ContributorPicker;
